import {
	UPLOAD_RESOURCE,
	UPDATE_RESOURCE_UPLOAD_PROGRESS,
	REMOVE_RESOURCE,
	ENQUEUE_FILE
} from '@/redux/actions/resources.actions'

const initialState = {
	queue: [],
	processed: []
}

const queue = (state = initialState.queue, action) => {
	switch (action.type) {
		case UPDATE_RESOURCE_UPLOAD_PROGRESS:
			return state.map((resource) =>
				resource.requestUuid === action.payload.requestUuid
					? { ...resource, progress: action.payload.progress }
					: resource
			)

		case UPLOAD_RESOURCE.FAILURE:
			return state.filter((resource) => resource.requestUuid !== action.payload.requestUuid)

		case ENQUEUE_FILE:
			return [
				...state,
				{
					id: null,
					loaded: false,
					error: null,
					progress: 0,
					...action.payload
				}
			]

		case UPLOAD_RESOURCE.SUCCESS:
			return state.filter((resource) => resource.requestUuid !== action.payload.requestUuid)

		default:
			return state
	}
}

const processed = (state = initialState.processed, action) => {
	switch (action.type) {
		case UPLOAD_RESOURCE.FAILURE:
			return [
				...state,
				{
					...state.find((resource) => resource.requestUuid === action.payload.requestUuid),
					fileName: action.payload.file.name,
					error: action.payload.error
				}
			]

		case REMOVE_RESOURCE:
			return state.filter((resource) => resource.requestUuid !== action.payload.requestUuid)

		case UPLOAD_RESOURCE.SUCCESS:
			return [
				...state,
				{
					fileName: action.payload.details.name,
					id: action.payload.details._id,
					loaded: true,
					error: false
				}
			]
		default:
			return state
	}
}

export default {
	name: 'resources',
	reducers: {
		queue,
		processed
	}
}
